import { useContext } from "react";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import GiftCardDetail from "@components/store/product-detail/gift-card/gift-card-detail";
import ProductCarousel from "@components/store/product-detail/shared/product-detail-carousel";
import ProductDetailHeader from "@components/store/product-detail/shared/product-detail-header";

import useProductDetailMultipleVariantsState from "@hooks/product-detail/use-product-details-multiple-variants-state";

import { useProductInfoContext } from "@contexts/product-info-context";

import styles from "./main.module.scss";

const GiftCard = ({ product, masterVariant, canBuyProduct }) => {
  const { modalClasses, hidePriceDetail } = useProductInfoContext();

  const { productImgClass = "", productContentClass = "" } = modalClasses;

  const {
    optionTypeVariantMapping,
    setOptionTypeVariantMapping,
    productQuantity,
    setProductQuantity,
    optionTypesData,
    variantValues,
    getDisplayPrice,
  } = useProductDetailMultipleVariantsState({ product, masterVariant });

  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const renderProductDetailHeader = () => (
    <ProductDetailHeader
      displayPrice={!hidePriceDetail && getDisplayPrice()}
      showProductName
      product={product}
    />
  );

  const renderProductDetails = () => (
    <GiftCardDetail
      product={product}
      optionTypesData={optionTypesData}
      variantValues={variantValues}
      optionTypeVariantMapping={optionTypeVariantMapping}
      setOptionTypeVariantMapping={setOptionTypeVariantMapping}
      productQuantity={productQuantity}
      setProductQuantity={setProductQuantity}
      canBuyProduct={canBuyProduct}
      renderProductDetailHeader={renderProductDetailHeader}
    />
  );

  return (
    <div className={`${styles.rowProductDetail} ${styles.rowWithV2Enabled}`}>
      {isMobileDevice && renderProductDetailHeader()}
      <div className={`${styles.productCarousalWrapper} ${productImgClass}`}>
        <ProductCarousel
          sliderImages={[variantValues[0]]}
          imageMagnify
          productId={product.id}
          product={product}
        />
        {/*ToDo: Need to fix sliderImages prop which is sending a new array in prop every time this
          component gets re-rendered*/}
      </div>
      <article className={`${styles.productDetail} ${productContentClass}`}>
        <div className={styles.productDetailBox}>{renderProductDetails()}</div>
      </article>
    </div>
  );
};

export default GiftCard;
